export const DND_TYPES = {
  CARD: 'CARD',
  IMAGE: 'IMAGE',
  ISSUE: 'ISSUE',
};
